<template>
  <div :style="{ 'top': top, 'left': left, 'text-align': 'center' }"
       @contextmenu="showContextMenu($event)"
       @click="showUITextDetails($event)"
  >
    <span><span class="subheading">{{ myText.label }}</span></span>
  </div>
</template>

<script>
  export default {
    name: "UIText",

    props: {
      myText: Object,
      bookingMode: Boolean
    },

    computed: {
      containerWidth() {
        return this.myText.width + 'px';
      },
      top() {
        return this.myText.y + 'px';
      },
      left() {
        return this.myText.x + 'px';
      },
    },

    methods: {
      showContextMenu(e) {
        this.$emit('show-ui-text-context-menu', e);
      },
      showUITextDetails(e) {
        this.$emit('show-ui-text-details', e);
      }
    },

    mounted() {
      let self = this;

      // Initialize jquery.pep.js
      if (! this.bookingMode) {
        $(this.$el).pep({
          constrainTo: 'parent',
          useCSSTranslation: false,
          rest: function(ev,obj) {
            self.$emit('text-moved', { x: obj.pos.x, y: obj.pos.y });
          }
        });
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/UIText.vue